var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLedSecondary = function SvgIconLedSecondary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#FF008E",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40-360v-80h160v80zm214-210L141-683l56-57 113 114zm26 330v-120h400v120zm160-440v-200h80v200zm266 110-56-56 113-113 57 56zm54 210v-80h160v80z"
  })));
};
export default SvgIconLedSecondary;